<script setup lang="ts">

</script>

<template>
  <div class="section-3">
    <IntroductionSponsors lg:mt-100px />
  </div>
</template>

<style scoped>
</style>
